import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import useMenuItems from "./useMenuItems";

export interface Crumb { label: string; to?: string; }

export function useBreadcrumb(): Crumb[] {
  const location = useLocation();
  const menuItems = useMenuItems();
  return useMemo(() => {
    const path = location.pathname;
    if (!path || path === "/") return [];
    const crumbs: Crumb[] = [];
    for (const item of menuItems) {
      if (!item.enabled) continue;
      if (item.sublinks) {
        const matches = item.sublinks.filter(
          sub => sub.enabled && (path === sub.to || path.startsWith(sub.to + "/"))
        );
        if (matches.length > 0) {
          const best = matches.sort((a, b) => (b.to?.length ?? 0) - (a.to?.length ?? 0))[0];
          crumbs.push({ label: item.label, to: item.to });
          crumbs.push({ label: best.label, to: best.to });
          break;
        }
      } else if (item.to && (path === item.to || path.startsWith(item.to + "/"))) {
        crumbs.push({ label: item.label, to: item.to });
        break;
      }
    }
    return crumbs;
  }, [location.pathname, menuItems]);
}
